import { createNode, PlainDateDataType } from '@glueapp/graph-types';
import { toPlainDate, fromPlainDate } from '../../utils/temporal';

export const SetDateComponents = createNode({
    id: 'Set Date Components',
    name: 'Set Date Components',
    description: 'Creates a new Date with one or more components replaced',
    aiDescription:
        'Takes a Date on the "Date" port and optional number overrides on "Year", "Month", and "Day" ports, and outputs a new Date on the "Date" port with the specified components replaced.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Date: PlainDateDataType,
        Year: { kind: 'number' },
        Month: { kind: 'number' },
        Day: { kind: 'number' },
    },
    optionalInPorts: ['Year', 'Month', 'Day'],
    outPorts: {
        Date: PlainDateDataType,
    },
    execute: function (input) {
        const date = toPlainDate(input.inPorts.Date);
        const overrides: Record<string, number> = {};
        if (input.inPorts.Year != null) overrides.year = input.inPorts.Year;
        if (input.inPorts.Month != null) overrides.month = input.inPorts.Month;
        if (input.inPorts.Day != null) overrides.day = input.inPorts.Day;
        const result = date.with(overrides);
        return { output: { Date: fromPlainDate(result) } };
    },
});
